var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        title: _vm.getTitle,
        "dialog-classes": "connect-reservation-system",
      },
      model: {
        value: _vm.modelActive,
        callback: function ($$v) {
          _vm.modelActive = $$v
        },
        expression: "modelActive",
      },
    },
    [
      _vm.step == 1
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "connect-reservation-system__description" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "connect-reservation-system__description--item",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.translations.selectDescription1.text) +
                          "\n        "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.translations.selectDescription2.text) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c("div", [
                    _vm._v(_vm._s(_vm.translations.selectDescription3.text)),
                  ]),
                ]
              ),
              _c("div", { staticClass: "connect-reservation-system__label" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.translations.yourReservationSystem.text) +
                    "\n    "
                ),
              ]),
              _c("v-select", {
                attrs: {
                  error: _vm.$v.reservationSystem.$error,
                  "error-message": _vm.translations.fieldNotEmpty.text,
                  items: _vm.normalizedReservationSystemTypes,
                  translates: _vm.reservationSystemTypes,
                  placeholder: _vm.translations.selectOne.text,
                },
                model: {
                  value: _vm.$v.reservationSystem.$model,
                  callback: function ($$v) {
                    _vm.$set(_vm.$v.reservationSystem, "$model", $$v)
                  },
                  expression: "$v.reservationSystem.$model",
                },
              }),
              _vm.isBokun || _vm.isOther
                ? _c("v-input", {
                    attrs: {
                      label: _vm.isBokun
                        ? _vm.translations.accountId.text
                        : "Other",
                      error: _vm.$v.info.$error,
                      "error-message": _vm.translations.fieldNotEmpty.text,
                      placeholder: _vm.isBokun
                        ? _vm.translations.introduceId.text
                        : "Introduce the system that you work with",
                    },
                    model: {
                      value: _vm.$v.info.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.info,
                          "$model",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "$v.info.$model",
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _c("div", [
            _vm.isBokun
              ? _c("div", { staticClass: "bokun_root" }, [
                  _c(
                    "div",
                    { staticClass: "connect-reservation-system__bokun--text" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.translations.bokunText1.text) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "connect-reservation-system__bokun--title" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.translations.bokunText2.text) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "ul",
                    _vm._l(_vm.bokunSteps, function (stepText, idx) {
                      return _c("li", { key: idx }, [_vm._v(_vm._s(stepText))])
                    }),
                    0
                  ),
                ])
              : _c("div", [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.translations.descLarge.text) +
                      "\n    "
                  ),
                ]),
          ]),
      _c(
        "div",
        { staticClass: "connect-reservation-system__footer" },
        [
          _c("v-btn", { attrs: { outline: "" }, on: { click: _vm.cancel } }, [
            _vm._v(_vm._s(_vm.translations.cancelButton.text)),
          ]),
          _c(
            "v-btn",
            {
              attrs: {
                base: "",
                loading: _vm.loading,
                "loading-name": "Connects...",
              },
              on: { click: _vm.next },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.step === 1
                      ? _vm.translations.nextButton?.text
                      : _vm.translations.saveButton.text
                  ) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }